import React, { useContext, useState } from "react";
import CenterModal from "../../Components/CenterModal";
import { MemberDetails } from "../../Contexts/MemberDetailContext";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import { passwordValidator } from "../../Utils/validation/validators";
import { postData } from "../../Utils/AxiosRequest";
import {
  API_PATHS,
  errorMessages,
  URL_PATH,
} from "../../Utils/Constants/constants";
import { encryptPassword } from "../../Utils/Auth/encription";
import { Spinner } from "react-bootstrap";
import InputField from "../../Components/InputField";
import { generateMathCaptcha } from "../../Utils/Auth/captchaAuth";
import Captcha from "./Captcha";

const ChangePassword = () => {
  // const captchaSiteKey = process.env.REACT_APP_CAPTCHA_SITEKEY;
  const { memberDetails } = useContext(MemberDetails);
  const [captchaToken, setCaptchaToken] = useState(generateMathCaptcha());
  const [userCaptcha, setUserCaptcha] = useState("");

  const { updateToastMessage } = useOutletContext();

  const [passwordError, setPasswordError] = useState(null);
  const [isPassDirty, setIsDirty] = useState(false);

  const [data, setData] = useState({
    Password: "",
    CurrentPassword: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState({
    heading: "",
    description: "",
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name === "Password" && isPassDirty) {
      const isPassValid = passwordValidator(value);
      if (isPassValid !== true) {
        setPasswordError(isPassValid);
      } else {
        setPasswordError(null);
      }
    }

    if (
      name === "CurrentPassword" &&
      passwordError === "Password and confirm password does not match."
    ) {
      if (data.CurrentPassword === value) {
        setPasswordError(null);
      }
    }
    setData((prvs) => {
      const newData = { ...prvs, [name]: value };
      return newData;
    });
  };

  const handleCaptchaChange = () => {
    setCaptchaToken(generateMathCaptcha());
    setUserCaptcha("");
  };

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    if (captchaToken) {
      setShowModal(true);
      setMessage({
        heading: "Invalid Captcha",
        description: "Please complete CAPTCHA verification",
      });
      return;
    }
    setIsDirty(true);
    if (!data.Password) {
      return;
    }
    if (data.Password.length < 8) {
      setPasswordError("Password should be atleast 8 characters.");
      return;
    }
    if (data.Password.length > 32) {
      setPasswordError("Password can not be greater than 32 characters.");
      return;
    }
    if (data.Password !== data.CurrentPassword) {
      setPasswordError("Password and confirm password does not match.");
      return;
    }
    setIsSubmitting(true);
    const reqBody = {
      UserId: memberDetails.MemberId,
      NewPassword: encryptPassword(data.Password),
      OldPassword: encryptPassword(data.CurrentPassword),
    };

    try {
      const response = await postData(API_PATHS.changePassword, reqBody);

      if (response.status === 200) {
        if (response.data.IsSuccess) {
          updateToastMessage("Password changed successfully.", "success");
          setData({
            Password: "",
            CurrentPassword: "",
          });
          navigate(URL_PATH.memberhome);
        } else {
          handleCaptchaChange();
          switch (message) {
            case "OTP mismatch!!!":
              setShowModal(true);
              setMessage({
                heading: "Invalid OTP",
                description: "OTP is invalid.",
              });
              break;
            case "OTP expired!!!":
              setShowModal(true);
              setMessage({
                heading: "Invalid OTP",
                description: "OTP Expired.",
              });
              break;
            default:
              setShowModal(true);
              setMessage({
                heading: errorMessages.error,
                description: errorMessages.errorDescription,
              });
          }
        }
      } else {
        handleCaptchaChange();
        setShowModal(true);
        setMessage({
          heading: errorMessages.error,
          description: errorMessages.description,
        });
      }
    } catch (error) {
      handleCaptchaChange();
      console.error(error);
      setShowModal(false);
      setMessage({
        heading: errorMessages.error,
        description: errorMessages.description,
      });
    }
    setIsSubmitting(false);
  };
  return (
    <section className="mt-5">
      <h3 className="main-title mb-3">Change Password</h3>
      <div className="wizard memnership-form py-5 px-4">
        <form onSubmit={handleUpdatePassword}>
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <InputField
                  type="email"
                  placeholder="Email"
                  name="Email"
                  value={memberDetails.Email}
                  autoComplete="off"
                  disabled
                />
              </div>
            </div>

            <div className="col-sm-12">
              <div className="form-group">
                <InputField
                  type="password"
                  placeholder="Confirm Password"
                  name="CurrentPassword"
                  value={data.CurrentPassword}
                  onChange={handleChange}
                  autoComplete="off"
                  required
                />
              </div>
            </div>

            <div className="col-sm-12">
              <div className="form-group">
                <InputField
                  type="password"
                  placeholder="Password"
                  name="Password"
                  value={data.Password}
                  onChange={handleChange}
                  autoComplete="off"
                  required
                />
              </div>
            </div>

            {passwordError && (
              <div className="pb-2 px-3">
                <p className="text-danger text-left p-0 m-0">{`* ${passwordError}`}</p>
              </div>
            )}
            {data.Password && data.CurrentPassword ? (
              <div className="d-flex justify-content-center py-2 px-3">
                {/* <ReCAPTCHA
                                sitekey={captchaSiteKey}
                                onChange={handleCaptchaChange}
                            /> */}
                <Captcha
                  captcha={captchaToken}
                  setUserCaptcha={setUserCaptcha}
                  userCaptcha={userCaptcha}
                  refreshCaptcha={handleCaptchaChange}
                />
              </div>
            ) : (
              <></>
            )}
            <div className="col-sm-12">
              <div className="form-group">
                {isSubmitting ? (
                  <button className="btn green-btn cursor-na" disabled>
                    <Spinner size="sm" />
                  </button>
                ) : (
                  <input
                    type="submit"
                    className="btn green-btn"
                    value="Submit"
                  />
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
      <CenterModal
        show={showModal}
        onClose={() => {
          setShowModal(false);
        }}
        heading={message.heading}
        description={message.description}
        buttonText={"Try again"}
      />
    </section>
  );
};

export default ChangePassword;
